import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../elements/ButtonLink';
import ToolbarLayout from '../../../elements/ToolbarLayout';
import StartNetworkingFooterButton from '../../StartNetworking/StartNetworkingFooterButton/StartNetworkingFooterButton';
import FooterButtonsLayout from '../../../elements/FooterButtonsLayout';

const CommonMeetingsFooter = (props) => {
    const { event } = props,
        i18n = useI18n();

    return (
        <FooterButtonsLayout>
            <ButtonLink className="secondary outline" href={['.', 'availability'].join('/')}>
                {i18n['label.manage-availability']}
            </ButtonLink>
            <StartNetworkingFooterButton event={event} />
        </FooterButtonsLayout>
    );
};

export default CommonMeetingsFooter;
